<template>

    <v-button-toolbar class="w-fluid">
        <v-input-group class="w-50p" prefix-icon="fas fa-calendar">
            <v-date-picker :model="params.date" @input="setDate" />
        </v-input-group>
        <v-input-group class="w-50p" prefix-icon="fas fa-clock">
            <v-select class="w-fluid" :model="params.time" @input="setTime">
                <option v-for="slot in slots" :key="slot" :value="slot">{{ slot | time }}</option>
            </v-select>
        </v-input-group>
    </v-button-toolbar>

</template>

<script>

import DatePicker from '@forms/DatePicker';
import moment from 'moment';

export default {

    components: {
        'v-date-picker': DatePicker,
    },

    props: {
        model: {
            required: true,
        },
    },

    data() {
        return {
            slots: [],
            params: {
                date: null,
                time: null,
            },
        }
    },

    created() {
        this.makeSlots();
        // Make date.
        this.params.date = this.model;
        // Make time.
        let m = this.model ? moment.unix(this.model) : moment();
        if (!m.isValid() || m.isBefore(moment())) {
            m = moment(); // Fallback to now if invalid, null, or past.
        }
        this.params.time = m
            .minute(Math.ceil(moment().minute() / 5) * 5)
            .second(0)
            .millisecond(0)
            .format('HH:mm:ss');
    },

    methods: {

        makeSlots() {
            for (let hour = 0; hour < 24; hour++) {
                for (let minute = 0; minute < 60; minute += 5) {
                    let formattedHour = hour.toString().padStart(2, '0');
                    let formattedMinute = minute.toString().padStart(2, '0');
                    this.slots.push(`${formattedHour}:${formattedMinute}:00`);
                }
            }
        },

        setDate(val) {
            this.params.date = val;
            let [hours, minutes] = this.params.time.split(':').map(Number);
            let m = moment.unix(val).clone();
            m.hour(hours).minute(minutes).second(0).millisecond(0);
            this.$emit('input', m.unix());
        },

        setTime(val) {
            this.params.time = val;
            let [hours, minutes] = val.split(':').map(Number);
            let m = moment.unix(this.params.date).clone();
            m.hour(hours).minute(minutes).second(0).millisecond(0);
            this.$emit('input', m.unix());
        },

    },

}

</script>
